import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c09fd84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title text-center" }
const _hoisted_2 = { class: "nav-box d-flex" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "submit-wrapper" }

import { reactive, ref, computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { FormItem } from '@/types/form';
  import { useRouter } from 'vue-router';
  import { request, alert } from '@/utils';

  type From = {
    email?: string,
    phone_number?: string,
    verification_code: string,
    password: string,
    password_confirmation: string,
    g_recaptcha_response?: string
  }

  type CodeTargetType = 'phone_number' | 'email'
  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const phoneNumberDialCode = ref('');

  const { t, locale } = useI18n();
  const router = useRouter();

  const codeTargetType = ref<CodeTargetType>('email');
  const form = reactive<From>({
    email: undefined,
    phone_number: undefined,
    verification_code: '',
    password: '',
    password_confirmation: '',
    g_recaptcha_response: ''
  });
  const editNav: Array<{ name: string, key: CodeTargetType }> = [
    { name: t('EMAIL'), key: 'email' },
    { name: t('PHONE NUMBER'), key: 'phone_number' }
  ];
  const formConfigs = computed<FormItem[]>(() => {
    const isEmail = codeTargetType.value === 'email';
    return [
      {
        label: t(isEmail ? 'EMAIL' : 'PHONE NUMBER'),
        type: 'input',
        inputType: isEmail ? 'email' : 'tel',
        key: codeTargetType.value,
        required: true,
        placeholder: isEmail ? 'name@email.com' : '01012340000'
      },
      {
        label: t('CAPTCHA'),
        type: 'custom',
        required: true,
        placeholder: 'Captcha',
        key: 'g_recaptcha_response',
        inputType: 'text',
      },
      {
        label: t('VERIFICATION CODE'),
        type: 'input',
        key: 'verification_code',
        required: true,
        placeholder: ''
      },
      {
        label: t('PASSWORD'),
        type: 'input',
        inputType: 'password',
        key: 'password',
        required: true,
        placeholder: '',
        triggerPwd: true
      },
      {
        label: t('CONFIRM PASSWORD'),
        type: 'input',
        inputType: 'password',
        key: 'password_confirmation',
        required: true,
        placeholder: '',
        triggerPwd: true
      }
    ];
  });

  function formItemChange(data: any) {
    form[data.key] = data.value;
  }

  function handleGetPhoneNumberCountry(country: any) {
    phoneNumberDialCode.value = country.dialCode;
  }

  function handleReset() {
    form.g_recaptcha_response = '';
  }
  async function handleSubmit() {
    const body: From = {
      verification_code: form.verification_code,
      password: form.password,
      password_confirmation: form.password_confirmation
    };
    if (codeTargetType.value === 'email') {
      body['email'] = form.email;
    } else {
      body['phone_number'] = `+${phoneNumberDialCode.value} ${form.phone_number}`;
    }
    if (form.password !== form.password_confirmation) {
      alert({ title: t('Inconsistent password input') });
      return;
    }
    await request.post('/password/reset_password', body);
    alert({ title: t('Success'), content: t('Operation success') });
    router.replace({ name: 'login' });
  };

return (_ctx: any,_cache: any) => {
  const _component_AppCountrySelector = _resolveComponent("AppCountrySelector")!
  const _component_GoogleRecaptcha = _resolveComponent("GoogleRecaptcha")!
  const _component_AppVerificationCodeBtn = _resolveComponent("AppVerificationCodeBtn")!
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)("Reset password")), 1),
    _createVNode(_component_b_form, {
      class: "form-box",
      onSubmit: handleSubmit
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(editNav, (item, index) => {
            return _createElementVNode("div", {
              key: index,
              class: _normalizeClass(["nav-item", { active: item.key === codeTargetType.value }]),
              onClick: ($event: any) => (codeTargetType.value = item.key)
            }, _toDisplayString(item.name), 11, _hoisted_3)
          }), 64))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formConfigs), (item) => {
          return (_openBlock(), _createBlock(_component_AppFormGroupItem, {
            key: item.key,
            form: _unref(form),
            config: item,
            onChange: formItemChange
          }, _createSlots({
            inputAfter: _withCtx(() => [
              (item.key === 'verification_code')
                ? (_openBlock(), _createBlock(_component_AppVerificationCodeBtn, {
                    key: 0,
                    target: codeTargetType.value === 'email' ? (_unref(form).email || '') : `+${phoneNumberDialCode.value} ${_unref(form).phone_number}`,
                    captcha: _unref(form).g_recaptcha_response,
                    "target-type": codeTargetType.value,
                    insert: "none",
                    event: "reset_password",
                    "show-count-down": false,
                    onReset: handleReset
                  }, null, 8, ["target", "captcha", "target-type"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, [
            (item.key === 'phone_number')
              ? {
                  name: "inputBefore",
                  fn: _withCtx(() => [
                    _createVNode(_component_AppCountrySelector, {
                      "country-code": _unref(locale),
                      onExcountry: handleGetPhoneNumberCountry
                    }, null, 8, ["country-code"])
                  ])
                }
              : undefined,
            (item.key === 'g_recaptcha_response')
              ? {
                  name: "custom",
                  fn: _withCtx(() => [
                    _createVNode(_component_GoogleRecaptcha, {
                      modelValue: _unref(form)['g_recaptcha_response'],
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form)['g_recaptcha_response']) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                }
              : undefined
          ]), 1032, ["form", "config"]))
        }), 128)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_b_button, {
            pill: "",
            variant: "primary",
            size: "lg",
            type: "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('Reset password')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})